import {
  AirportLogLocation,
  CustomAddressLogLocation,
  FacilityLogLocation,
  HomeAddressLogLocation,
  LegLocationTypeEnum,
} from '@/api/apis/route';
import { getLocationAddress, pickLocationDisplayName } from '@/utils/helpers';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

type ChangeLogLocationNameProps = {
  location: AirportLogLocation | FacilityLogLocation | HomeAddressLogLocation | CustomAddressLogLocation | null;
};

export const ChangeLogLocationName = ({ location }: ChangeLogLocationNameProps) => {
  const { resolveSubdivisionName, extendLocation } = useCountriesData();

  if (!location) return null;

  switch (location.locationType) {
    case LegLocationTypeEnum.airport:
      if (location.fboLocation?.id) {
        return (
          <>
            <span className="text-s-m text-base-5 mr-1">{`FBO ${location.iata || location.icao}`}</span>
            <span className="text-s-r text-base-20">{`${location.fboLocation.address.addressLine1 || location.fboLocation.address.addressLine2}, ${location.fboLocation.address.city}`}</span>
          </>
        );
      }

      return <span className="text-s-m text-base-5">{location.iata || location.icao}</span>;
    case LegLocationTypeEnum.hub:
      return <span className="text-s-m text-base-5">{`${location.name} (${location.code})`}</span>;
    case LegLocationTypeEnum.hospital:
      return (
        <span className="text-s-m text-base-5">{`DH, ${pickLocationDisplayName(extendLocation({ location }))}`}</span>
      );
    case LegLocationTypeEnum.txcenter:
      return (
        <span className="text-s-m text-base-5">{`TXC, ${pickLocationDisplayName(extendLocation({ location }))}`}</span>
      );
    case LegLocationTypeEnum.homeResidence:
    case LegLocationTypeEnum.custom:
    default:
      return (
        <span className="text-s-r text-base-20">{getLocationAddress(location.location, resolveSubdivisionName)}</span>
      );
  }
};
